
// 퍼블 id : UX_04_006
import dayjs from 'dayjs'
import { throttle } from 'lodash'
import { pdMixin } from '@/mixin/pd/pdMixin'
import orMixin from '~/mixin/or/orMixin'
import { groobeeUtil } from '@/mixin/groobeeUtil'
import BreadCrumb from '@/components/pd/common/BreadCrumb.vue' // bread crumb
import PdInfoUnit from '@/components/pd/common/PdInfoUnit.vue' // 상품정보 unit
import PdRevwCttsSwiper from '@/components/pd/common/PdRevwCttsSwiper.vue' // 상품 리뷰 컨텐츠 thumb
import { isShowTotalSelling } from '~/config/options'

import ScrPdr000c1 from '@/components/pd/pdr/SCR_PDR_000C_1.vue' // 혜택정보
import ScrPdr000c2 from '@/components/pd/pdr/SCR_PDR_000C_2.vue' // 배송안내
import ScrPdr000c3 from '@/components/pd/pdr/SCR_PDR_000C_3.vue' // 옵션정보
import ScrPdr000c4 from '@/components/pd/pdr/SCR_PDR_000C_4.vue' // 상품설명(에디터 영역)
import ScrPdr000c5 from '@/components/pd/pdr/SCR_PDR_000C_5.vue' // 리뷰
import ScrPdr000c7 from '@/components/pd/pdr/SCR_PDR_000C_7.vue' // 상품정보(제공 고시)
import ScrPdr000c8 from '@/components/pd/pdr/SCR_PDR_000C_8.vue' // 추천상품 리스트
import ScrPdr000c9 from '@/components/pd/pdr/SCR_PDR_000C_9.vue' // 배너
import PdPurchaseBanner from '@/components/pd/pdr/PdPurchaseBanner.vue' // 배너

import LayerShareSns from '@/components/common/shareSns.vue' // 공유하기 팝업
import LayerCpnDown from '@/components/pd/layer/LayerCpnDown.vue' // 적용 가능한 쿠폰 받기 팝업
import LayerDlvInfo from '@/components/pd/layer/LayerDlvInfo.vue' // 배송정보 자세히보기 팝업
import LayerRevwDtl from '@/components/pd/layer/LayerRevwDtl.vue' // 리뷰 상세 보기 레이어 팝업
import LayerRevwStmt from '@/components/pd/layer/LayerRevwStmt.vue' // 리뷰 신고하기 레이어 팝업
import LayerRevwCttsClt from '@/components/pd/layer/LayerRevwCttsClt.vue' // 리뷰 컨텐츠 모아보기 레이어
import LayerQnaWrt from '@/components/pd/layer/LayerQnaWrt.vue' // 상품 문의 레이어 팝업
import ScrOrc0001T4P2 from '@/pages/or/orc/SCR_ORC_0001_T4_P2.vue' // 대량배송 서비스 안내 팝업
import { pushGtmData } from '~/utils/gtm'
import { prodTag } from '~/utils/criteo'
import { commonfunc } from '~/mixin/common'

export default {
  key (route) {
    return route.fullPath
  },
  components: {
    BreadCrumb,
    PdInfoUnit,
    PdRevwCttsSwiper,
    ScrPdr000c1,
    ScrPdr000c2,
    ScrPdr000c3,
    ScrPdr000c4,
    ScrPdr000c5,
    ScrPdr000c7,
    ScrPdr000c8,
    ScrPdr000c9,
    PdPurchaseBanner,
    LayerShareSns,
    LayerCpnDown,
    LayerDlvInfo,
    LayerRevwDtl,
    LayerRevwStmt,
    LayerRevwCttsClt,
    LayerQnaWrt,
    ScrOrc0001T4P2
  },
  mixins: [pdMixin, groobeeUtil, orMixin, commonfunc],
  layout: 'DsMainLayout',
  // layout: 'pubLayout',
  // middleware: 'authroute',
  asyncData ({ $api }) {
    return $api
  },
  data () {
    return {
      isShowTotalSelling,
      pdNo: this.$route.query.pdNo, // 상품번호
      adltCtfcYn: this.$store.getters['session/getAdltCtfcYn'], // 성인인증 여부
      viewType: '', // 화면 구성 타입 (gnr: 일반, bun: 세트상품, gf: 상품권)
      pkgList: [],
      // api result
      pdDescRslt: {}, // 상품상세 내용, md공지, tqc공지
      pdNtfcRslt: {}, // 상품상세 고시정보
      pdRevwSmryRslt: {}, // 상품상세 리뷰 정리
      topBanrRslt: {}, // 상단배너
      midBanrRslt: {}, // 중간배너
      bnfInfoRslt: {}, // 혜택정보
      cpnInfoRslt: {}, // 쿠폰정보
      dlvcPlcy: {}, // 배송정책 (bassDlvAm: 기본배송비, retnDlvAm: 반품배송비, exchDlvAm: 교환배송비, stdrAm: 무료배송금액, fdrmStdrAm: 정기배송금액)
      dlvcPlcyLoad: {
        pdsDlvc: false,
        fdrmDlvc: false,
        pkupPlcy: false,
        quickPlcy: false,
        massPlcy: false
      },
      pdUnit: {}, // 상품정보
      brndUnit: {}, // 브랜드정보
      revwCnt: 0, // 리뷰 건수
      revwAvg: '0', // 리뷰 평점
      pdRevwCttsCnt: 0, // 리뷰 컨텐츠 건수 셋팅
      reloadQna: false, // qna 작성 후 reload flag
      qnaCnt: 0, // qna 건수
      selPdList: [], // 선택한 옵션정보 리스트
      selOpt: '', // 선택 옵션 품번(옵션선택 셀렉트박스 동기화)
      tabs: {}, // tab list
      crumbs: [], // bread crumb
      shareData: {}, // sns share data
      activeTab: '1', // tab active initialization [ 1: 상품설명, 2: 리뷰,  3: QnA, 4: 상품정보(제공 고시) ]
      scrollY: 0, // scrollTop
      tabBlank: 104, // tab height (nav + topmargin)
      tabMove: false, // 탭 클릭 스크롤 이벤트 작동 체크
      tabMoveTarget: 0, // 클릭 탭 offsetTop
      purchaseValue: '01', // 01: 택배배송, 02: 매장픽업, 03:정기배송, 04: 대량배송
      isMassDlvUnable: false, // 대량배송불가 여부
      isPkupDlvUnable: false, // 매장픽업불가 여부
      isQuickDlvUnable: false, // 오늘배송불가 여부
      dlvDt: '',
      massDlvDt: '',
      regDlvDt: '',
      massOfflCntrStck: 0, // 대량주문 재고수량
      pkupOfflStrStck: 0, // 매장픽업 재고수량
      quickOfflStrStck: 0, // 오늘배송 재고수량
      isGoMass: false,
      sideBarPkgYn: false, // 덕용 상품일 때 사이드바 총 개수 및 금액 계산을 위한 값
      isOpenRun: false, // 오픈런상품여부
      revwCttsList: [], // 리뷰컨텐츠 리스트
      isSelRevwCttsReload: false, // 리뷰컨텐츠 리로드
      revwCttsTotalCnt: 0, // 리뷰컨텐츠 갯수
      inRoute: this.$route.query.route, // 상품상세 들어온 경로 recmYn 제외 01 : 택배재입고알림, 02 : 바코드 검색 03 : 매장재입고알림
      infoParam: {
        mbMngNo: this.getMbMngNo(), // 회원관리번호
        pdNo: this.$route.query.pdNo
      },
      opRunAncYn: 'N', // 판매시작알림신청여부
      opRunShareData: {}, // 판매시작알림 공유하기데이터
      opRunDt: '', // 판매시작일시
      largeCategory: '', // GTM 데이터 수집을 위한 대카테고리
      midCategory: '', // GTM 데이터 수집을 위한 중카테고리
      smallCategory: '', // GTM 데이터 수집을 위한 소카테고리
      isSaving: false, // 재입고알림신청중
      isZziming: false, // 찜중
      groobeeRecmData: {},
      cmmnCdList: [],
      recommendData: '' // 문장형 추천 문구
    }
  },
  head () {
    return {
      title: this.unescape(this.pdUnit.exhPdNm),
      meta: [
        { hid: 'og:title', property: 'og:title', content: this.unescape(this.pdUnit.exhPdNm) },
        { hid: 'og:url', property: 'og:url', content: window.location.href },
        // ...this.setGroobeeMeta()
      ],
      // script: [...this.setGroobeeScript()],
      // __dangerouslyDisableSanitizers: ['script'] // 그루비처리시 필요
    }
  },
  computed: {
    revwRating () {
      // 별점, 리뷰갯수 최소값 미충족 시 미노출()
      return this.revwCnt >= 10 && parseFloat(this.revwAvg) >= 1
    },
    showRevw () { // revw 탭 내용 노출 여부
      return this.viewType === 'gnr'
    },
    showQna () { // qna 탭 내용 노출 여부
      return (this.viewType === 'gf' || this.viewType === 'gnr')
    },
    dlvcPlcyLoaded () { // 배송정책 api 전체 로드 여부
      return this.dlvcPlcyLoad.pdsDlvc && this.dlvcPlcyLoad.fdrmDlvc && this.dlvcPlcyLoad.pkupPlcy && this.dlvcPlcyLoad.quickPlcy && this.dlvcPlcyLoad.massPlcy
    },
    isOpt () {
      if (this.isNotEmpty(this.pdUnit.pdOpt)) {
        return this.pdUnit.pdOpt.length > 0
      }
      return false
    }
  },
  watch: {
    pdRevwSmryRslt: {
      // 리뷰정보 가져오기
      handler (o) {
        if (this.isNotEmpty(o.data.pdRevw)) {
          this.revwAvg = o.data.pdRevw.revwAvg
          this.revwCnt = o.data.pdRevw.revwCnt
        }
      },
      deep: true
    },
    purchaseValue (item) {
      if (this.isOpt) {
        this.selPdList = []
        if (item === '04' && this.pdUnit.pdTy !== '05') {
          const pdLsit = [
            {
              cnt: this.pdUnit.htrkCnvMummQy * this.pdUnit.jpQy,
              exhPdNm: this.pdUnit.exhPdNm,
              gfId: null,
              imgUrl: this.pdUnit.imgUrl,
              maxOrPsblQy: (Math.floor(this.massOfflCntrStck / this.pdUnit.jpQy)) * this.pdUnit.jpQy,
              onldPdNo: this.pdUnit.pdNo,
              optCn: null,
              pdNm: this.pdUnit.exhPdNm,
              pdNo: this.pdUnit.pdNo,
              pdPrc: this.pdUnit.pdPrc,
              rowId: '01',
              soldout: false,
              stckQy: this.massOfflCntrStck
            }
          ]
          this.selPdList = pdLsit
        }
      } else if (this.selPdList.length > 0) {
        if (this.selPdList[0].optYn === 'Y') { // 1개 이상 옵션 상품이 체크된 경우
          this.selPdList = [] // 칩 변경 시 옵션선택 리스트 초기화
        } else if (this.selPdList[0].cnt) {
          this.selPdList[0].cnt = 1
        }
      }

      this.sideBarPkgYn = false // 사이드바 덕용 상품 여부 초기화
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleThrottledScroll)
  },
  beforeMount () {
    window.addEventListener('scroll', this.handleThrottledScroll)
  },
  async mounted () {
    // 스크롤 탑 셋팅
    window.scrollTo({ top: 0, left: 0 })
    this.$nuxt.$emit('page-mounted')

    // 상품 정보 조회
    if (this.pdNo) {
      // 상품 기본정보 조회
      await this.$AxiosBuilder
        .data({ pdNo: this.pdNo })
        .build()
        .post('/pd/pdr/pdDtl/selPdDtlInfo')
        .then((res) => {
          if (res.data.success) {
            const pdInfo = res.data.data

            // 성인인증 필요 상품 메시지 출력
            if (pdInfo.buyLmtAgeCd === '03' && this.adltCtfcYn !== 'Y') {
              this.setAdltMsg()
              return
            }
            this.pdUnit = {}
            this.setViewTab(res.data.extraData.viewType) // view type 에 따른 탭 setting
            this.setPdDtlData(pdInfo) // 상품상세 데이터 셋팅

            // 덕용상품
            if (pdInfo.pkgYn === 'Y') {
              const pkgData = res.data.extraData.pkgList
              this.setPkgList(pkgData)
            }

            // api 순차 로드
            this.pdApi(this.pdNo).forEach(async (o) => {
              await this.$api.post(o.url, o.param).then((res) => {
                if (Array.isArray(o.name) && this.isNotEmpty(res.data.data.dlvcPlcyList)) {
                  console.log('배송비정책', res.data.data.dlvcPlcyList)
                  for (const dlvplcyVO of res.data.data.dlvcPlcyList) {
                    if (dlvplcyVO.dlvcPlcyCd === 'DLVC000001') {
                      this.dlvcPlcy.bassDlvAm = dlvplcyVO.bassDlvAm
                      this.dlvcPlcy.retnDlvAm = dlvplcyVO.retnDlvAm
                      this.dlvcPlcy.exchDlvAm = dlvplcyVO.exchDlvAm
                      this.dlvcPlcy.stdrAm = dlvplcyVO.stdrAm
                      this.dlvcPlcyLoad.pdsDlvc = true
                    } else if (dlvplcyVO.dlvcPlcyCd === 'DLVC000002') {
                      this.dlvcPlcy.fdrmStdrAm = dlvplcyVO.stdrAm // 정기배송금액
                      this.dlvcPlcyLoad.fdrmDlvc = true
                    } else if (dlvplcyVO.dlvcPlcyCd === 'DLVC000005') {
                      this.dlvcPlcyLoad.quickPlcy = true
                      this.dlvcPlcy.quickBassDlvAm = dlvplcyVO.bassDlvAm
                      this.dlvcPlcy.quickStdrAm = dlvplcyVO.stdrAm
                      this.dlvcPlcy.quickFreeDlvAm = dlvplcyVO.freeDlvAm
                    } else if (dlvplcyVO.dlvcPlcyCd === 'DLVC000003') {
                      this.dlvcPlcyLoad.massPlcy = true
                      this.dlvcPlcy.massStdrAm = dlvplcyVO.stdrAm
                      this.dlvcPlcy.massFourBassDlvAm = dlvplcyVO.bassDlvAm
                    } else if (dlvplcyVO.dlvcPlcyCd === 'DLVC000004') {
                      this.dlvcPlcy.massTwoBassDlvAm = dlvplcyVO.bassDlvAm
                    }
                  }
                } else if (o.name === 'pkupPlcy') {
                  this.dlvcPlcy.pkupAm = res.data.data.bassDlvAm // 픽업수수료
                  this.dlvcPlcyLoad.pkupPlcy = true
                } else if (o.name === 'pdDesc') { // 상품상세 내용, md공지, tqc공지
                  this.pdDescRslt = res.data
                  if (this.isNotEmpty(res.data.data.pdDtlDesc.brnd)) {
                    this.brndUnit = res.data.data.pdDtlDesc.brnd
                  }
                } else {
                  this[`${o.name}Rslt`] = res.data
                }
                this.$nextTick(() => {
                  // qna 통해서 상품상세 접근한 경우, api 호출 이후 qna 탭으로 스크롤 자동 이동
                  if (this.$route.query.qna === 'Y') {
                    document.getElementsByClassName('wrap')[0].scrollTo({ top: document.getElementsByClassName('tab-cont qna')[0].offsetTop - 150 })
                  }
                })
              }).catch((e) => {
                console.log('pdApi error :', e)
              })
            })
            this.selBluxRecommendText()
          } else {
            this.$alert(this.unescape(res.data.message), {
              dangerouslyUseHTMLString: true,
              callback: () => {
                this.$router.go(-1)
              }
            })
          }

          this.callAirBridgeForProductView()
        }).catch((e) => {
          console.log('selPdDtlInfo error :', e)
        })
    } else {
      // 상품 정보가 존재하지 않습니다.
      this.alert(this.$t('PD.UNAVAILABLE'), {
        okCallback: () => {
          this.$router.go(-1)
        }
      })
    }

    if (this.inRoute === '01') { // 01 : 택배재입고알림, 02 : 바코드 03 : 매장재입고알림
      // 택배재입고알림 gtmp pus
      console.log('택배재입고알림gtm푸쉬')
    }

    // Criteo 파라미터 세팅
    const tagItem = {
      pdNo: this.pdUnit.pdNo ?? '', // 상품번호
      email: '', // 이메일
      zipCode: '' // 배송지 우편번호
    }

    prodTag(tagItem)
    pushGtmData(this.pdUnit, 'view')
    this.ntcnDate()
  },
  updated () {

  },
  methods: {
    handleThrottledScroll: throttle(function () { this.scrollEvent() }, 50),
    setViewTab (viewType) {
      this.viewType = viewType
      switch (viewType) {
        case 'bun': // 세트상품
          this.tabs = {
            ds: { title: '상품설명' },
            info: { title: '상품정보' }
          }
          break
        case 'gf': // 상품권
          this.tabs = {
            ds: { title: '상품설명' },
            info: { title: '상품정보' }
          }
          break
        case 'gnr': // 일반(gnr)
          this.tabs = {
            ds: { title: '상품설명' },
            revw: { title: '리뷰', revwCnt: 0 },
            info: { title: '상품정보' }
          }
          break
        default:
          break
      }
    },
    // 덕용상품 데이터 셋팅
    setPkgList (data) {
      this.pkgList = data
      this.pkgList.forEach((pkg, index) => {
        this.$set(this.pkgList, index, { ...pkg, disabled: false })
      })
    },
    callAirBridgeForProductView () { // 에어브릿지 상품상세 조회 이벤트호출
      const productInfo = new this.$airbridge.ProductObject(this.pdUnit.pdNo, this.pdUnit.exhPdNm, this.pdUnit.pdPrc, this.pdUnit.brndCd, this.pdUnit.onlLclNm, 1, '')
      this.$airbridge.viewProduct(productInfo)
    },
    // 상품정보 셋팅
    async setPdDtlData (pdInfo) {
      this.pdUnit = pdInfo
      this.pdUnit.exhPdNm = this.unescape(pdInfo.exhPdNm)
      this.pdUnit.brndNm = this.unescape(pdInfo.brndNm)
      this.pdUnit.pdNo = this.pdNo // 품번
      this.pdUnit.cnt = 1 // 초기 갯수
      // this.pdUnit.imgUrl = pdInfo.imgUrl // 이미지 url
      this.pdUnit.orCnt = !this.isNotEmpty(pdInfo.orCnt) ? 0 : pdInfo.orCnt // 주문건수
      this.pdUnit.exhCtgr = pdInfo.exhCtgr // 전시카테고리 정보
      this.massOfflCntrStck = Math.floor(100 * pdInfo?.jpQy) // 대량주문 재고수량 기본 값 세팅
      this.pkupOfflStrStck = 1 // 매장픽업 재고수량 기본 값 세팅
      this.quickOfflStrStck = 1 // 오늘배송 재고수량 기본 값 세팅
      this.isOpenRun = !!(pdInfo.strgyPdYn && dayjs(new Date()).format('YYYYMMDDHH') < pdInfo.sleStDtm)

      // 상품 이미지 리스트
      if (pdInfo.ctts.length) { this.setCtts(pdInfo.ctts) }

      // 상품 매핑 전시카테고리 bread crumb 정보 셋팅
      if (pdInfo.exhCtgr.length) { this.setExhCtgr(pdInfo.exhCtgr) }

      // 상품 엠블럼 리스트 셋팅
      if (pdInfo.emblm.length) { this.setEmblm(pdInfo.emblm) }

      // 상품 옵션정보 셋팅
      if (pdInfo.onldOpt.length || this.viewType === 'gf') { this.setOnldOpt(pdInfo.onldOpt) }

      // 세트상품 구성 상품 셋팅
      if (pdInfo.bunPd.length) { this.setOnldOpt(pdInfo.bunPd) }

      // 로컬스토리지 셋팅
      this.setLocalStoragePdDtl()

      // 그루비 데이터 셋팅
      await this.setGroobee()
      await this.getGroobeeData()

      this.setGtmDataAttribute() // GTM 데이터 셋팅 추가

      // 혜택/쿠폰정보 조회
      this.$nextTick(() => {
        // 혜택정보 파라메타 셋팅
        const pdNoList = []
        if (this.viewType === 'bun') {
          this.selPdList.forEach((pd) => {
            pdNoList.push({ pdNo: pd.pdNo })
          })
        } else {
          pdNoList.push({ pdNo: this.pdNo })
        }
        // 혜택관련 api 순차로드(전달 파라메타 구조가 달라 따로 호출)
        this.pdEvApi().forEach(async (o) => {
          await this.$api.post(o.url, { pdNoList }).then((res) => {
            this[`${o.name}Rslt`] = res.data
          }).catch((e) => {
            console.log('pdEvApi error :', e)
          })
        })
        this.shareData.title = this.viewType !== 'bun' ? String(this.pdUnit.pdPrc) + '원' : this.pdUnit.exhPdNm
        this.shareData.description = this.pdUnit.pdTy === '06' ? '[박스배송]' + this.pdUnit.exhPdNm : this.pdUnit.exhPdNm
        this.shareData.imgUrl = this.pdUnit.imgUrl
      })

      if (this.isOpenRun) {
        await this.$AxiosBuilder // 판매시작알림신청공유하기템플릿
          .data({ mbMngNo: this.getMbMngNo(), pdNo: this.$route.query.pdNo })
          .build()
          .post('/pdo/selOpRunNtcnTmpl')
          .then((res) => {
            const result = res.data
            if (result.success) {
              this.opRunShareData = {
                title: result.data.tmplSj,
                description: result.data.tmplCn,
                imgUrl: result.data.imgUrl
              }
            }
          }).catch((e) => {
            console.log('selOpRunNtcnTmpl error :', e)
          })
        if (this.isLogin) {
          await this.$AxiosBuilder // 판매시작알림신청여부
            .data(this.infoParam)
            .build()
            .post('/pdo/selOpRunNtcnStat')
            .then((res) => {
              const result = res.data
              if (result > 0) {
                this.opRunAncYn = 'Y'
              } else {
                this.opRunAncYn = 'N'
              }
            }).catch((e) => {
              console.log('selOpRunNtcnStat error :', e)
            })
        }
      }
    },

    // 성인인증 필요 상품 메시지 출력
    setAdltMsg () {
      if (!this.isLogin) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
      } else if (this.adltCtfcYn !== 'Y') {
        // 성인인증이 필요한 상품입니다. 성인인증을 진행하시겠습니까?
        this.confirm(this.$t('SM.CERTIFY_ADULT'), {
          okCallback: () => {
            this.$router.push({
              name: 'mb-mbc-SCR_MBC_0110A_01',
              path: '/mb/mbc/SCR_MBC_0110A_01',
              params: { redirectUrl: `/pd/pdr/SCR_PDR_0001?pdNo=${this.pdNo}&recmYn=${this.$route.query.recmYn}` } // 모바일은 /pd/pdl/SCR_PDL_0001 로 변경

            })
          },
          cancelCallback: () => {
            // 뒤로가기
            this.$router.go(-1)
          }
        })
      }
    },

    setCtts (ctts) {
      this.pdUnit.ctts = [] // 초기화
      ctts.forEach((item, idx) => {
        let videoOpt = {}
        if (item.pdCttsTy === '02' && this.isNotEmpty(item.imgUrl)) { // 동영상이고 url이 있을 때 비디오 옵션 추가
          videoOpt = { // video 기본 옵션 설정
            controls: false, // 컨트롤 바 노출 여부
            autoplay: true, // 자동재생
            muted: true, // 음소거
            loop: true, // 반복재생
            preload: 'auto', // 즉시 비디오 데이터를 다운로드 시작할지 여부 결정
            poster: '', // 썸네일 이미지
            playbackRates: [1] // 배속
          }
        }
        const obj = {
          id: 'detail' + String(idx),
          pdCttsTy: item.pdCttsTy, // 컨텐츠 유형 (01: 이미지, 02: 동영상)
          imgUrl: item.imgUrl, // url
          videoOpt
        }
        this.pdUnit.ctts.push(obj)
      })
    },

    // 상품 매핑 전시카테고리 bread crumb 정보 셋팅
    setExhCtgr (exhCtgr) {
      this.crumbs = [
        {
          id: '0',
          tit: '홈',
          link: '/'
        },
        {
          id: exhCtgr[0].lctgrNo, // 대카
          tit: exhCtgr[0].lctgrNm,
          link: `/ds/exhCtgr/C208/${exhCtgr[0].lctgrNo}`
        },
        {
          id: exhCtgr[0].mctgrNo, // 중카
          tit: exhCtgr[0].mctgrNm,
          link: `/ds/exhCtgr/C208/${exhCtgr[0].lctgrNo}/${exhCtgr[0].mctgrNo}`
        },
        {
          id: exhCtgr[0].sctgrNo, // 소카
          tit: exhCtgr[0].sctgrNm,
          link: `/ds/exhCtgr/C208/${exhCtgr[0].lctgrNo}/${exhCtgr[0].mctgrNo}/${exhCtgr[0].sctgrNo}`
        }
      ]
    },

    // 상품 이미지 리스트
    setEmblm (emblm) {
      this.pdUnit.emblm = [] // 초기화
      emblm.forEach((item) => { // 전시 등록 엠블럼 노출
        const obj = {
          name: item.emblmNm,
          imgUrl: item.pcIconUrl,
          emNm: item.imgRplcTextNm,
          aplMdiaPcomYn: item.aplMdiaPcomYn,
          aplMdiaMblYn: item.aplMdiaMblYn,
        }
        this.pdUnit.emblm.push(obj)
      })
    },

    // 상품 옵션정보 셋팅
    setOnldOpt (pdOpt) {
      this.pdUnit.pdOpt = [] // 옵션리스트
      this.selPdList = [] // 선택한 상품(옵션)리스트

      if (this.viewType === 'gf') {
        // 상품권일 때는 옵션리스트 만들어주고, 선택 품목 선택리스트에 선 등록
        this.pdUnit.pdOpt = pdOpt
        const opt = pdOpt.find(o => o.onldPdNo === this.pdNo)
        this.selPdList.push({ cnt: 1, ...opt })
      } else if (this.viewType === 'bun') {
        // 세트상품 때 옵션으로 만들어 줌
        pdOpt.forEach((item) => {
          this.selPdList.push({
            rowId: item.rowId,
            pdNo: item.pdNo,
            onldPdNo: item.onldPdNo,
            exhPdNm: this.unescape(item.exhPdNm),
            maxOrPsblQy: item.maxOrPsblQy,
            pdPrc: item.pdPrc,
            compQy: item.compQy,
            pdImgUrl: item.imgUrl,
            optCn: this.unescape(item.optCn),
            pdCttSty: item.pdCttsTy,
            cnt: item.compQy,
            bunCnt: 1,
            bunQy: item.bunQy
          })
        })
        this.selPdList[0].bunCnt = 1
      } else if (pdOpt.length > 1) {
        // 옵션정보가 두개 이상일 때 옵션리스트만 등록
        this.pdUnit.pdOpt = pdOpt
      } else {
        // 옵션이 한개일 때 선택리스트에 상품정보 선 등록
        this.pdUnit.onldPdNo = pdOpt[0].onldPdNo // 온라인 전용 품번
        this.selPdList.push({ cnt: 1, ...pdOpt[0] })
      }
    },

    // 로컬스토리지 등록
    setLocalStoragePdDtl () {
      // 묶음상품은 제외
      if (this.viewType === 'bun') { return }
      const visitedPdNo = []
      const localStoragePdNo = JSON.parse(localStorage.getItem('visitedPdNo'))
      if (localStoragePdNo !== undefined && localStoragePdNo != null) {
        visitedPdNo.push(...localStoragePdNo)
      }
      const d = new Date()
      //  yyyymmddhhmmss 포멧 UTC -> KST
      const currentTime = new Date(d.getTime() - (d.getTimezoneOffset() * 60000)).toISOString().replace(/(\.\d{3})|[^\d]/g, '')
      const exhCtgrLNo = this.pdUnit.exhCtgr.length === 0 ? '' : this.pdUnit.exhCtgr[0].lctgrNo
      const idx = visitedPdNo.findIndex(r => r.pdNo === this.pdNo)
      if (idx === -1) {
        visitedPdNo.push({ pdNo: this.pdNo, time: currentTime, exhCtgrLNo })
      } else {
        visitedPdNo[idx].time = currentTime
      }
      visitedPdNo.sort((a, b) => {
        return b.time - a.time
      })
      if (visitedPdNo.length > 24) {
        visitedPdNo.splice(24)
      }
      localStorage.setItem('visitedPdNo', JSON.stringify(visitedPdNo))
    },

    // 그루비 데이터 셋팅
    setGroobee () {
      this.setGroobeeDtl([{
        name: this.pdUnit.exhPdNm, // 상품명
        code: this.pdNo, // URL에 표시되는 상품코드
        amt: this.pdUnit.pdPrc, // 상품금액 (할인판매가 X 수량)
        prc: this.pdUnit.pdPrc, // 판매가 (또는 원가)
        salePrc: this.pdUnit.pdPrc, // 할인 판매가 (실제 판매가)
        img: this.replaceImg(this.pdUnit.imgUrl), // 상품 이미지 전체 URL
        status: this.pdUnit.sleStsCd === '03' ? '' : 'SS', // 상품 판매 상태(품절 이거나 판매중이 아닌경우 SS 입력)
        cat: this.pdUnit.exhCtgr.length === 0 ? '' : this.isOpt ? 'Y' : 'N', // 상품의 카테고리코드
        cateNm: this.pdUnit.exhCtgr.length === 0 ? '' : this.isOpt ? '옵션' : '단품', // 상품의 카테고리명
        catL: this.pdUnit.exhCtgr.length === 0 ? '' : this.pdUnit.exhCtgr[0].lctgrNo, // 상품의 대분류 카테고리코드
        cateLNm: this.pdUnit.exhCtgr.length === 0 ? '' : this.pdUnit.exhCtgr[0].lctgrNm, // 상품의 대분류 카테고리명
        catM: this.pdUnit.exhCtgr.length === 0 ? '' : this.pdUnit.exhCtgr[0].mctgrNo, // 상품의 중분류 카테고리코드
        cateMNm: this.pdUnit.exhCtgr.length === 0 ? '' : this.pdUnit.exhCtgr[0].mctgrNm, // 상품의 중분류 카테고리명
        catS: this.pdUnit.exhCtgr.length === 0 ? '' : this.pdUnit.exhCtgr[0].sctgrNo, // 상품의 소분류 카테고리코드
        cateSNm: this.pdUnit.exhCtgr.length === 0 ? '' : this.pdUnit.exhCtgr[0].sctgrNm, // 상품의 소분류 카테고리명
        catD: this.pdUnit.exhCtgr.length === 0 ? '' : this.isOpt ? 'Y' : 'N', // 상품의 세분류 카테고리코드 : 옵션상품유무 값 전달
        cateDNm: this.pdUnit.exhCtgr.length === 0 ? '' : this.isOpt ? '옵션' : '단품', // 상품의 세분류 카테고리명
        brand: this.pdUnit.brndCd, // 상품의 브랜드코드
        brandNm: this.pdUnit.brndNm, // 상품의 브랜드명
        plan: [] // 상품이 속한 기획전(관련 컨텐츠) 코드
      }])
    },

    /* component emit start */
    // 선택한 옵션정보 저장
    syncOptData (data) {
      if (data.type === 'ins') {
        this.selOpt = data.pdNo
        if (this.selPdList.findIndex(o => o.onldPdNo === data.pdNo) > -1) {
          // 이미 선택한 옵션입니다.
          this.$alert(this.$t('PD.ALREADY_SELECT_OPTION'), {
            dangerouslyUseHTMLString: true,
            center: true
          })
        } else {
          // 옵션 첫 선택
          const opt = this.pdUnit.pdOpt.find(o => o.onldPdNo === data.pdNo)
          // 덕용 상품은 첫 셋팅 1 아닌 라디오 선택 숫자
          if (this.pdUnit.pkgYn === 'Y') {
            this.selPdList.push({ cnt: data.cnt, ...opt })
          } else if (this.pdUnit.pdTy === '05' && this.purchaseValue === '04') {
            this.selPdList.push({ cnt: data.cnt, optYn: 'Y', ...opt })
          } else {
            // 덕용 상품 아닌 경우 셀렉트 박스 선택시 기본 1 셋팅
            this.selPdList.push({ cnt: 1, optYn: 'Y', ...opt })
          }
        }
      } else if (data.type === 'del') {
        this.selPdList = this.selPdList.filter(o => o.onldPdNo !== data.pdNo)
        this.selOpt = '' // 옵션 select box 초기화
      } else if (data.type === 'cnt') {
        if (this.viewType === 'bun') {
          this.selPdList[0].bunCnt = data.cnt
          // this.selPdList.map((o) => {
          //   o.cnt = o.compQy * data.cnt
          //   return o
          // })
        } else {
          this.selPdList.map((o) => {
            if (o.onldPdNo === data.pdNo) {
              if (data.pkgYn === 'Y') {
                o.cnt = data.cnt
                o.pkgYn = data.pkgYn
              } else {
                o.cnt = data.cnt
              }
            }
            return o
          })
        }
      }
    },

    // 리뷰 컨텐츠 갯수 셋팅
    setRevwCttsCnt (val) {
      this.pdRevwCttsCnt = val
    },

    // qna cnt setting
    setPdDtlQna (data) {
      this.qnaCnt = data.qnaCnt
      this.reloadQna = false
    },
    // 덕용상품 라디오 변경
    pkgChange (data) {
      this.selPdList[0].cnt = data
    },
    disabledPkg (i, bool) {
      this.pkgList[i].disabled = bool
    },
    // 찜하기 토글
    tglPdZzim () {
      if (!this.isLogin) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return
      }

      if (this.isZziming) {
        return
      }

      this.isZziming = true
      this.$AxiosBuilder
        .data({ pdNo: this.pdNo })
        .build()
        .post('/pd/pdr/pdDtl/tglPdDtlZzim')
        .then((res) => {
          this.isZziming = false
          if (res.data.success) {
            this.pdUnit.zzimYn = res.data.extraData.zzimYn ? 'Y' : 'N'
            // 상품을 찜했습니다., 찜하기가 해제되었습니다.
            const msg = this.pdUnit.zzimYn === 'Y' ? this.$t('PD.ZZIM_SUCCESS') : this.$t('PD.ZZIM_CANCEL')
            this.openToast(msg)
            if (this.pdUnit.zzimYn === 'Y') {
              this.callAirBridgeForAddToWishiList()
            }
          }
        }).catch((e) => {
          this.isZziming = false
          console.log('SCR_PDR_000C tglPdZzim error : ', e)
        })

      pushGtmData(this.pdUnit, 'wishlist') // 찜하기 성공시 GTM DataLayer Push 실행
    },
    callAirBridgeForAddToWishiList () {
      const productInfo = new this.$airbridge.ProductObject(this.pdUnit.pdNo, this.pdUnit.exhPdNm, this.pdUnit.pdPrc, this.pdUnit.brndCd, this.pdUnit.onlLclNm, 1, '')
      this.$airbridge.addToWishiList(productInfo)
    },

    // 판매/재입고 알림 신청 토글
    tglWrhAnc (param) {
      if (!this.isLogin) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return
      }

      try {
        this.$AxiosBuilder
          .data([param])
          .build()
          .post('/pdo/togSleParmNtcn')
          .then((res) => {
            const result = res.data.data[0]
            if (param.ancTy === '01') {
              this.$refs.scrPdr000c3t.ancYn = result.useYn // 상단
              this.$refs.scrPdr000c3s.ancYn = result.useYn // 사이드
              if (result.useYn === 'Y') {
                // 판매 시작 알림이 신청되었습니다.
                this.openToast(this.$t('PD.NOTIFY_NEWPD_SUCCESS'))
              } else {
                // 판매 시작 알림이 취소되었습니다.
                this.openToast(this.$t('PD.NOTIFY_NEWPD_CANCEL'))
              }
            } else {
              // 재입고 알림이 신청되었습니다.
              this.openToast(this.$t('PD.NOTIFY_RESTOCK_SUCCESS'))
            }
          })
      } catch (e) {
        console.log('SCR_PDR_000C_3 wrhAnc error : ', e)
      }
    },
    // 재입고알림 요청
    tglReWrhNtcn (param) {
      if (!this.isLogin) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return
      }

      const onldOpt = this.pdUnit.onldOpt
      if (onldOpt.length === 1) {
        if (onldOpt[0].pdNo !== onldOpt[0].onldPdNo) {
          console.log('자체적으로 옵션상품이 단품화된 사례')
          param.onldPdNo = onldOpt[0].onldPdNo
        }
      }

      if (this.isSaving) {
        return
      }

      // 재입고 알림 신청
      this.isSaving = true
      try {
        this.$AxiosBuilder
          .data([param])
          .build()
          .post('/pdo/regReWrhNtcn')
          .then((res) => {
            this.isSaving = false
            const result = res?.data?.data
            if (result?.success) {
              if (result?.message === 'Y') {
                // 재입고 알림이 신청되었습니다.
                this.openToast(this.$t('PD.NOTIFY_RESTOCK_SUCCESS', { ntcnParam: this.unescape(result?.extraString) }))
              } else if (result?.message === 'E') {
                this.openToast(this.$t('PD.NOTIFY_RESTOCK_RQT_LIMIT', { param: result?.extraString }))
              } else if (result?.message === 'X') {
                this.openToast(this.$t('PD.NOTIFY_RESTOCK_EXCEPT_PD'))
              } else {
                this.openToast(this.$t('PD.NOTIFY_ALREADY_RESTOCK'))
              }
            }
            console.log(res.data.data)
          }).catch((e) => {
            this.isSaving = false
            console.error('SCR_PDR_000C_3 regReWrhNtcn error :', e)
          })
      } catch (e) {
        this.isSaving = false
        console.log('SCR_PDR_000C_3 regReWrhNtcn error : ', e)
      }
    },
    // 매장재입고알림요청
    notiStrReWrhNtcn (param) {
      if (!this.isLogin) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
      } else {
        const ua = window.navigator.userAgent.toLowerCase()

        this.$AxiosBuilder
          .data(param)
          .build()
          .post('ms/msg/selStrReWrhNtcnExist')
          .then((res) => {
            const result = res?.data
            if (result?.success) {
              this.$notify({
                message: this.$t('PD.NOTIFY_ALREADY_RESTOCK'),
                position: 'center',
                center: true,
                showClose: false,
                duration: 2000,
                dangerouslyUseHTMLString: true,
                onClick: () => { this.$notify.closeAll() }
              })
              // 이미 등록된 재입고 알림 신청 내역이 있습니다.
            } else if (!this.isMobile(ua)) {
              this.$notify({
                message: this.$t('PD.STR_RE_WRH_NTCN_ONLY_MO'),
                center: true,
                position: 'center',
                showClose: false,
                duration: 2000,
                dangerouslyUseHTMLString: true,
                onClick: () => {
                  this.$notify.closeAll()
                }
              }) // 매장 재입고 알림은 모바일을 통해서만 신청 가능합니다. <br>앱을 다운로드 받은 후 재입고알림을 신청해 주세요.
            }
          }).catch((e) => { console.log('error', e) })
      }
    },
    // 판매시작알림신청
    async regOpRunNtcn () {
      if (!this.isLogin) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return
      }
      const params = [{ pdNo: this.pdUnit.pdNo, mbMngNo: this.getMbMngNo() }] // 판매시작알림신청
      await this.$AxiosBuilder
        .data(params)
        .build()
        .post('/pdo/regOpRunNtcn')
        .then((res) => {
          if (res.data.success) {
            this.opRunAncYn = 'Y'
            this.openToast(this.$t('PD.NOTIFY_OPENRUN_SUCCESS'))
          }
        }).catch((e) => {
          console.log('SCR_PDR_0001 regOpRunNtcn error :', e)
        })
    },

    // 판매시작알림해제
    async delOpRunNtcn () {
      const params = [{ pdNo: this.pdUnit.pdNo, mbMngNo: this.getMbMngNo() }]
      await this.$AxiosBuilder
        .data(params)
        .build()
        .post('/pdo/delOpRunNtcn')
        .then((res) => {
          if (res.data.success) {
            this.opRunAncYn = 'N'
            this.openToast(this.$t('PD.NOTIFY_OPENRUN_CANCEL'))
          }
        }).catch((e) => {
          console.log('SCR_PDL_000C_3 delOpRunNtcn error :', e)
        })
    },
    // blux 추천문구 조회
    selBluxRecommendText () {
      const params = { pdNo: this.pdUnit.pdNo, mbMngNo: this.getMbMngNo() }
      this.$AxiosBuilder
        .data(params)
        .build()
        .post('/pd/pdr/pdDtl/blux/rcm/prs')
        .then((res) => {
          if (res.data.success) {
            this.recommendData = res.data.data.recommendStr // blux 추천 문구
          }
        }).catch((e) => {
          console.log('SCR_PDL_000C_3 selBluxRecommendText error :', e)
        })
    },

    // open layer
    openLayer (layer) {
      switch (layer.name) {
        case 'dlvInfo': // 배송안내 팝업
          this.$refs.layerDlvInfo.visible = true
          break
        case 'revwDtl': // 리뷰 상세보기 팝업
          layer.data.isGrpPd = this.pdUnit.grpPdYn === 'Y'
          if (layer.data.isGrpPd) {
            layer.data.grpPdNo = this.pdUnit.pdNo
            layer.data.isBoxPd = this.pdUnit.pdTy === '06'
          }
          this.$refs.layerRevwDtl.data = layer.data
          this.$refs.layerRevwDtl.visible = true
          break
        case 'revwCttsClt': // 리뷰 컨텐츠 모아보기
          this.$refs.layerRevwCttsClt.data = layer.data
          this.$refs.layerRevwCttsClt.visible = true
          break
        case 'revwStmt': // 리뷰 신고하기 팝업
          this.$refs.layerRevwStmt.data = layer.data
          this.$refs.layerRevwStmt.visible = true
          break
        case 'qnaWrt': // QnA 작성
          this.$refs.layerQnaWrt.visible = true
          break
        case 'cpnDown': // 쿠폰 다운로드 팝업
          this.$refs.layerCpnDown.visible = true
          break
        case 'shareSns': // 공유하기 팝업
          this.$refs.layerShareSns.snsVisible = true
          break
        case 'MassInfo': // 대량주문 안내 팝업
          this.$refs.ScrOrc0001T4P2.dialogFormVisible = true
          break
        case 'dvyaPpup': // 배송지 추가/변경 팝업
          this.openDvyaChgPpup()
          break
      }
    },

    scrollEvent () {
      this.scrollY = window.scrollY
      // clickTabScroll 아닐 때
      if (!this.tabMove) {
        const tabCont = document.getElementsByClassName('tab-cont') // 상품 상세 탭 콘텐츠

        // 스크롤 이동 시 해당 탭 active 셋팅
        for (let idx = 0; idx < tabCont.length; idx++) {
          const tabContTop = tabCont[idx].getBoundingClientRect().top
          const tabContHeight = tabCont[idx].clientHeight

          if (tabContTop <= this.tabBlank && tabContTop + tabContHeight >= this.tabBlank) {
            this.activeTab = (idx + 1).toString()
          }
        }
      }
      // 클릭한 탭으로 스크롤 이동이 끝났을 때 다시 activeTab 작동 할 수 있도록
      if (this.tabMoveTarget === this.scrollY) {
        this.tabMove = false
      }
    },

    // 클릭한 탭으로 스크롤 이동
    clickTabScroll (tab, event) {
      this.tabMove = true
      const scrollAreaEl = window
      const targetTab = document.getElementsByClassName('tab-cont')[tab.name - 1]
      this.tabMoveTarget = targetTab.offsetTop - this.tabBlank
      scrollAreaEl.scrollTo({ top: this.tabMoveTarget, left: 0, behavior: 'smooth' })
    },

    setPurchaseValue (val) {
      this.purchaseValue = val
    },
    massDlvUnable (isMassDlvUnable) { // 대량배송 불가 여부
      this.isMassDlvUnable = isMassDlvUnable
    },
    pkupDlvUnable (isPkupDlvUnable) { // 매장픽업 불가 여부
      this.isPkupDlvUnable = isPkupDlvUnable
    },
    quickDlvUnable (isQuickDlvUnable) { // 매장픽업 불가 여부
      this.isQuickDlvUnable = isQuickDlvUnable
    },
    dlvParmDay (dlvDt) {
      this.dlvDt = dlvDt
    },
    massDlvParmDay (dlvDt) {
      this.massDlvDt = dlvDt
    },
    regDlvParmDay (dlvDt) {
      this.regDlvDt = dlvDt
    },
    setGoMass (val) {
      this.isGoMass = val
    },
    selOfflCntrStck (massStck) { // 대량주문 재고수량
      this.massOfflCntrStck = massStck[0]?.stck
    },
    selOfflStrStck (pkupStck) { // 매장픽업 재고수량
      if (this.pdUnit.pdTy === '05') {
        this.newPkupOfflStrStck = pkupStck
        if (pkupStck?.grpOfflStrStckList && pkupStck?.grpOfflStrStckList?.length > 0) { // 전용상품
          pkupStck.grpOfflStrStckList.forEach((stckInfo) => {
            const chkopt = this.pdUnit.pdOpt.find(pdOptInfo => pdOptInfo.onldPdNo === stckInfo.pdNo) // 옵션정보
            const chkopt2 = this.pdUnit.onldOpt.find(pdOptInfo => pdOptInfo.onldPdNo === stckInfo.pdNo) // 옵션정보
            chkopt.pkupStck = stckInfo.stck ? Number(stckInfo.stck) : 0
            chkopt2.pkupStck = stckInfo.stck ? Number(stckInfo.stck) : 0
            this.pkupOfflStrStck += Number(stckInfo.stck)
          })
        } else {
          this.pdUnit.pdOpt.forEach((item) => {
            item.pkupStck = 0
          })
        }
      } else {
        this.pkupOfflStrStck = parseInt(pkupStck[0]?.stck)
      }
    },
    selQuickOfflStrStck (quickStck) { // 오늘배송 재고수량
      if (this.pdUnit.pdTy === '05') {
        if (quickStck?.grpOfflStrStckList && quickStck?.grpOfflStrStckList?.length > 0) { // 전용상품
          quickStck.grpOfflStrStckList.forEach((stckInfo) => {
            const chkopt = this.pdUnit.pdOpt.find(pdOptInfo => pdOptInfo.onldPdNo === stckInfo.pdNo) // 옵션정보
            const chkopt2 = this.pdUnit.onldOpt.find(pdOptInfo => pdOptInfo.onldPdNo === stckInfo.pdNo) // 옵션정보
            chkopt.quickStck = stckInfo.stck ? parseInt(stckInfo.stck) : 0
            chkopt2.quickStck = stckInfo.stck ? parseInt(stckInfo.stck) : 0
            this.quickOfflStrStck += parseInt(stckInfo.stck)
          })
        } else {
          this.pdUnit.pdOpt.forEach((item) => {
            item.quickStck = 0
          })
        }
      } else {
        this.quickOfflStrStck = parseInt(quickStck[0]?.stck)
      }
    },
    setSideBarPkgYn (item) {
      this.sideBarPkgYn = item
    },
    setRevwCttsList (val) {
      this.revwCttsList = val.cttsList
      this.revwCttsTotalCnt = val.totalCnt
    },
    selRevwCttsReload () {
      this.isSelRevwCttsReload = !this.isSelRevwCttsReload
    },

    ntcnDate () { // 판매시작일 포맷설정
      const opTime = dayjs(this.pdUnit.sleStDtm).format('YYYY-MM-DD HH:mm:ss')
      let opRunTime = ''
      let amPm = ''

      if (opTime !== '') {
        const week = ['일', '월', '화', '수', '목', '금', '토']
        const month = new Date(opTime).getMonth() + 1
        const date = new Date(opTime).getDate()
        let time = new Date(opTime).getHours()
        const dayOfWeek = week[new Date(opTime).getDay()]
        if (time < 12) {
          amPm = '오전'
        } else {
          amPm = '오후'
          if (time !== 12) {
            time -= 12
          }
        }

        opRunTime = `${month}/${date}(${dayOfWeek}) ${amPm} ${time}시`
      }
      this.opRunDt = opRunTime
    },
    setGtmDataAttribute () {
      this.largeCategory = this.pdUnit.exhCtgr.length === 0 ? '' : this.pdUnit.exhCtgr[0].lctgrNm
      this.midCategory = this.pdUnit.exhCtgr.length === 0 ? '' : this.pdUnit.exhCtgr[0].mctgrNm
      this.smallCategory = this.pdUnit.exhCtgr.length === 0 ? '' : this.pdUnit.exhCtgr[0].sctgrNm
    },
    async getGroobeeData () {
      const grpList = ['CD_00573']
      this.cmmnCdList = await this.selCmmnCd(grpList) // 공통 코드
      const campaignKey = this.cmmnCdList.filter((item) => { return item.cmmnCd === '07' })[0].fstUserFd

      this.groobeeRecmData = await this.getGroobeeRecommendProd(campaignKey)
    }
  }
}
